(function () {
  if (typeof window === 'undefined') return;

  var GRADE_LABELS = {
    Select: 'G/SI1',
    Premium: 'F/VS2',
    Signature: 'E/VVS2',
  };

  function formatMass(value) {
    if (value == null || value === '') return null;
    var num = parseFloat(value);
    if (isNaN(num)) return String(value);
    return num.toFixed(2) + ' ct';
  }

  function getProductInfo(el) {
    return el && el.closest ? el.closest('product-info.livia-product') : null;
  }

  function getModal(productInfo) {
    if (!productInfo) return null;
    var meta = getProductMeta(productInfo);
    if (meta.sectionId) {
      return document.getElementById('LiviaShowroomModal-' + meta.sectionId);
    }
    return document.querySelector('modal-dialog.livia-showroom-modal');
  }

  function getModalFromTrigger(trigger) {
    var controls = trigger.getAttribute('aria-controls');
    if (controls) return document.getElementById(controls);
    return getModal(getProductInfo(trigger));
  }

  function getSelectedVariant(productInfo) {
    var script = productInfo && productInfo.querySelector('[data-selected-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getProductMeta(productInfo) {
    var script = productInfo && productInfo.querySelector('[data-livia-product-meta]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return {};
    }
  }

  function readOptionValue(productInfo, matchers) {
    var groups = productInfo.querySelectorAll('variant-selects .variant__option__group');
    for (var i = 0; i < groups.length; i++) {
      var legend = groups[i].querySelector('.variant__option__name');
      if (!legend) continue;
      var label = '';
      legend.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) label += node.textContent;
      });
      label = label.trim() || legend.textContent.trim();
      var lower = label.toLowerCase();
      if (!matchers.some(function (m) { return lower.indexOf(m) !== -1; })) continue;

      var selectedSpan = groups[i].querySelector('[data-selected-value]');
      if (selectedSpan && selectedSpan.textContent.trim()) {
        return selectedSpan.textContent.trim();
      }
      var checked = groups[i].querySelector('input[type="radio"]:checked, select option:checked');
      if (checked) return (checked.value || checked.textContent).trim();
    }
    return null;
  }

  function readMass(productInfo) {
    var active = productInfo.querySelector('.variant__option__values--mass a.active span');
    if (active) return active.textContent.trim();
    var legend = productInfo.querySelector('[data-mass-variants] .variant__option__name span');
    if (legend) return legend.textContent.trim();
    var meta = getProductMeta(productInfo);
    return meta.mass != null ? formatMass(meta.mass) : null;
  }

  function readQuality(productInfo) {
    var checked = productInfo.querySelector('.variant__option__values--jakosc input[type="radio"]:checked');
    if (!checked) return readOptionValue(productInfo, ['jako']);
    var tier = checked.value;
    var grades = GRADE_LABELS[tier] || '';
    return grades ? tier + ' (' + grades + ')' : tier;
  }

  function formatPricePln(cents) {
    if (cents == null || cents === '') return null;
    var value = Number(cents);
    if (isNaN(value)) return null;
    return value / 100;
  }

  function collectConfiguration(productInfo) {
    var variant = getSelectedVariant(productInfo);
    var meta = getProductMeta(productInfo);
    var pricePln = variant && variant.price != null ? formatPricePln(variant.price) : null;
    var config = {
      product: {
        id: meta.productId,
        title: meta.productTitle,
        handle: meta.productHandle,
        url: meta.productUrl,
        variantId: variant && variant.id,
        variantTitle: variant && variant.title,
        sku: variant && variant.sku,
        price: pricePln,
        priceFormatted: null,
      },
      configuration: {
        masa: readMass(productInfo),
        jakosc: readQuality(productInfo),
        zloto: readOptionValue(productInfo, ['kolor', 'złoto', 'zloto']),
        rozmiar: readOptionValue(productInfo, ['rozmiar']),
      },
    };

    var priceEl = productInfo.querySelector('#price-' + meta.sectionId + ' .price-item--regular, #price-' + meta.sectionId + ' .price-item--sale');
    if (priceEl) config.product.priceFormatted = priceEl.textContent.trim();
    else if (variant && variant.price) {
      config.product.priceFormatted = (variant.price / 100).toLocaleString('pl-PL', {
        style: 'currency',
        currency: 'PLN',
      });
    }

    return config;
  }

  function updateConfigSummary(productInfo) {
    var config = collectConfiguration(productInfo);
    var modal = getModal(productInfo);
    if (!modal) return;

    function setValue(key, value) {
      var el = modal.querySelector('[data-config-value="' + key + '"]');
      var row = modal.querySelector('[data-config-row="' + key + '"]');
      if (!el) return;
      if (value) {
        el.textContent = value;
        if (row) row.hidden = false;
      } else if (row) {
        row.hidden = true;
      }
    }

    setValue('product', config.product.title);
    setValue('mass', config.configuration.masa);
    setValue('quality', config.configuration.jakosc);
    setValue('gold', config.configuration.zloto);
    setValue('size', config.configuration.rozmiar);
    setValue('price', config.product.priceFormatted);
  }

  function setMinDate(modal) {
    var input = modal.querySelector('[data-showroom-date]');
    if (!input) return;
    var today = new Date();
    input.min = today.toISOString().slice(0, 10);
  }

  function showPanel(modal, name) {
    modal.querySelectorAll('[data-showroom-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-showroom-panel') !== name;
    });
  }

  function resetForm(modal) {
    var form = modal.querySelector('[data-showroom-form]');
    if (form) form.reset();
    showPanel(modal, 'form');
    setMinDate(modal);
  }

  function validateForm(form) {
    if (!form.checkValidity()) {
      form.reportValidity();
      return false;
    }
    var email = form.querySelector('[name="email"]');
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      email.setCustomValidity('Podaj prawidłowy adres e-mail.');
      email.reportValidity();
      email.setCustomValidity('');
      return false;
    }
    return true;
  }

  function getProductInfoFromModal(modal) {
    if (!modal || !modal.id) {
      return document.querySelector('product-info.livia-product');
    }

    var match = modal.id.match(/^LiviaShowroomModal-(.+)$/);
    if (match) {
      var byId = document.getElementById('MainProduct-' + match[1]);
      if (byId) return byId;

      var bySection = document.querySelector('product-info.livia-product[data-section="' + match[1] + '"]');
      if (bySection) return bySection;
    }

    return document.querySelector('product-info.livia-product');
  }

  function getModalFromForm(form) {
    return form.closest('modal-dialog.livia-showroom-modal');
  }

  function getWebhookUrl(modal) {
    return window.LIVIA_SHOWROOM_WEBHOOK || (modal && modal.dataset.showroomWebhook) || '';
  }

  function buildWebhookParams(payload) {
    var params = new URLSearchParams();
    params.set('submittedAt', payload.submittedAt || '');
    params.set('firstName', payload.contact.firstName || '');
    params.set('lastName', payload.contact.lastName || '');
    params.set('name', payload.contact.name || '');
    params.set('email', payload.contact.email || '');
    params.set('phone', payload.contact.phone || '');
    params.set('preferredDate', payload.appointment.date || '');
    params.set('preferredTime', payload.appointment.time || '');
    params.set('productId', payload.product.id != null ? String(payload.product.id) : '');
    params.set('productTitle', payload.product.title || '');
    params.set('productHandle', payload.product.handle || '');
    params.set('productUrl', payload.product.url || '');
    params.set('variantId', payload.product.variantId != null ? String(payload.product.variantId) : '');
    params.set('price', payload.product.price != null ? String(payload.product.price) : '');
    params.set('priceFormatted', payload.product.priceFormatted || '');
    params.set('masa', payload.configuration.masa || '');
    params.set('jakosc', payload.configuration.jakosc || '');
    params.set('zloto', payload.configuration.zloto || '');
    params.set('rozmiar', payload.configuration.rozmiar || '');
    params.set('payload', JSON.stringify(payload));
    return params;
  }

  function sendToWebhook(payload, modal) {
    var webhookUrl = getWebhookUrl(modal);
    if (!webhookUrl) return;

    var jsonBody = JSON.stringify(payload);
    var formBody = buildWebhookParams(payload).toString();

    fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: jsonBody,
      keepalive: true,
    }).catch(function () {
      return fetch(webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: formBody,
        keepalive: true,
      });
    }).catch(function () { /* nie blokuj ekranu sukcesu */ });
  }

  function handleSubmit(event, productInfo, modal) {
    event.preventDefault();
    var form = event.target.closest('[data-showroom-form]') || event.target;
    if (!form || !modal) return;
    if (!validateForm(form)) return;

    var config = productInfo ? collectConfiguration(productInfo) : { product: {}, configuration: {} };
    var formData = new FormData(form);
    var firstName = (formData.get('first_name') || '').trim();
    var lastName = (formData.get('last_name') || '').trim();
    var payload = {
      product: config.product,
      configuration: config.configuration,
      contact: {
        firstName: firstName,
        lastName: lastName,
        name: [firstName, lastName].filter(Boolean).join(' '),
        email: formData.get('email'),
        phone: formData.get('phone'),
      },
      appointment: {
        date: formData.get('preferred_date'),
        time: formData.get('preferred_time'),
      },
      submittedAt: new Date().toISOString(),
    };

    try {
      sessionStorage.setItem('livia_showroom_booking_' + Date.now(), JSON.stringify(payload));
    } catch (e) { /* ignore */ }

    window.dispatchEvent(new CustomEvent('livia:showroom-booking', { detail: payload }));

    sendToWebhook(payload, modal);

    showPanel(modal, 'success');
    resetModalScroll(modal);
  }

  var scrollLockY = 0;

  function lockPageScroll() {
    scrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('la-showroom-open');
    document.body.classList.add('la-showroom-open');
    document.body.style.top = '-' + scrollLockY + 'px';
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('la-showroom-open');
    document.body.classList.remove('la-showroom-open', 'overflow-hidden');
    document.body.style.top = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, scrollLockY);
  }

  function attachScrollUnlock(modal) {
    if (modal.dataset.showroomUnlockAttached) return;
    modal.dataset.showroomUnlockAttached = '1';

    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) {
        unlockPageScroll();
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function resetModalScroll(modal) {
    var dialog = modal.querySelector('.livia-showroom-modal__dialog');
    if (dialog) {
      dialog.scrollTop = 0;
      if (typeof dialog.scrollTo === 'function') {
        dialog.scrollTo(0, 0);
      }
    }
  }

  function openShowroomModal(modal, trigger) {
    lockPageScroll();
    modal.show(trigger);
    resetModalScroll(modal);
    requestAnimationFrame(function () {
      resetModalScroll(modal);
    });
  }

  document.body.addEventListener('modalClosed', function () {
    unlockPageScroll();
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-showroom-trigger]');
    if (trigger) {
      var productInfo = getProductInfo(trigger);
      var modal = getModalFromTrigger(trigger);
      if (!productInfo || !modal || typeof modal.show !== 'function') return;
      updateConfigSummary(productInfo);
      resetForm(modal);
      updateConfigSummary(productInfo);
      openShowroomModal(modal, trigger);
      return;
    }

    var closeSuccess = event.target.closest('[data-showroom-close-success]');
    if (closeSuccess) {
      var modalEl = closeSuccess.closest('modal-dialog.livia-showroom-modal');
      if (modalEl) {
        modalEl.hide();
        resetForm(modalEl);
      }
    }
  });

  document.addEventListener('change', function (event) {
    var productInfo = getProductInfo(event.target);
    if (!productInfo) return;
    if (event.target.matches('input[type="radio"], select')) {
      updateConfigSummary(productInfo);
    }
  });

  function attachFormHandler(modal) {
    if (modal.dataset.showroomFormAttached) return;
    modal.dataset.showroomFormAttached = '1';

    var form = modal.querySelector('[data-showroom-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      handleSubmit(event, getProductInfoFromModal(modal), modal);
    });
  }

  function initModals() {
    document.querySelectorAll('modal-dialog.livia-showroom-modal').forEach(function (modal) {
      setMinDate(modal);
      attachScrollUnlock(modal);
      attachFormHandler(modal);
    });
  }

  document.addEventListener('DOMContentLoaded', initModals);
  document.addEventListener('shopify:section:load', initModals);
  document.addEventListener('product-info:loaded', function (event) {
    var productInfo = event.target;
    if (productInfo && productInfo.classList.contains('livia-product')) {
      var modal = getModal(productInfo);
      if (modal) setMinDate(modal);
      updateConfigSummary(productInfo);
    }
  });
})();
